import React, { useState } from 'react';
import {
    Box,
    Button,
    Container,
    MenuItem,
    Select,
    Typography,
    FormControl,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    TablePagination,
    Chip,
    TextField,
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DownloadIcon from '@mui/icons-material/Download';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CircleIcon from '@mui/icons-material/Circle';

// ─── Mock Data ────────────────────────────────────────────────────────────────

const summaryCards = [
    { label: 'Breakdowns (Today)', value: '8', sub: 'Reported incidents', color: '#1976d2', bg: '#1976d2', icon: '📋' },
    { label: 'Total Cash Refund', value: 'LKR 245,600.00', sub: 'To be refunded by conductor', color: '#2e7d32', bg: '#2e7d32', icon: '💵' },
    { label: 'Total Digital Refund Due', value: 'LKR 536,800.00', sub: 'To be processed digitally', color: '#7b1fa2', bg: '#7b1fa2', icon: '💳' },
    { label: 'Net Cash Due to Depot', value: 'LKR 128,450.00', sub: 'From conductor after refunds', color: '#ed6c02', bg: '#ed6c02', icon: '🏦' },
    { label: 'Pending HO Authorization', value: 'LKR 236,800.00', sub: 'Digital refunds pending', color: '#d32f2f', bg: '#d32f2f', icon: '⏳' },
];

const breakdownEventRows = [
    { id: 1, refNo: 'BD-2604-0001', dateTime: '20/04/2026 07:35', busNo: 'NB-2567', route: '001 Colombo - Kandy', stage: 'Avissawella', conductor: 'EMP1025\nSunil Perera', pax: 38, cashRefund: 'LKR 88,800.00', digitalRefund: 'LKR 128,400.00', netCash: 'LKR 32,600.00', status: 'DEPOT_CONFIRMED' },
    { id: 2, refNo: 'BD-2604-0002', dateTime: '20/04/2026 09:15', busNo: 'ND-2599', route: '017 Kandy - Kurunegala', stage: 'Gampola', conductor: 'EMP1044\nNimal Fernando', pax: 29, cashRefund: 'LKR 42,300.00', digitalRefund: 'LKR 92,700.00', netCash: 'LKR 28,100.00', status: 'CASH_REFUND_IN_PROGRESS' },
    { id: 3, refNo: 'BD-2604-0003', dateTime: '20/04/2026 10:50', busNo: 'ND-3144', route: '025 Kurunegala - Puttalam', stage: 'Nikaweratiya', conductor: 'EMP1077\nPriyantha Silva', pax: 41, cashRefund: 'LKR 78,300.00', digitalRefund: 'LKR 138,800.00', netCash: 'LKR 63,300.00', status: 'DEPOT_DIGITAL_PENDING' },
    { id: 4, refNo: 'BD-2604-0004', dateTime: '20/04/2026 12:10', busNo: 'NC-1123', route: '027 Puttalam - Chilaw', stage: 'Dankotuwa', conductor: 'EMP1090\nRuwan Dias', pax: 22, cashRefund: 'LKR 32,600.00', digitalRefund: 'LKR 44,900.00', netCash: 'LKR 18,500.00', status: 'HO_AUTH_PENDING' },
    { id: 5, refNo: 'BD-2604-0005', dateTime: '20/04/2026 13:45', busNo: 'NB-2578', route: '003 Kandy - Matale', stage: 'Matale Town', conductor: 'EMP1025\nSunil Perera', pax: 31, cashRefund: 'LKR 48,700.00', digitalRefund: 'LKR 88,600.00', netCash: 'LKR 22,400.00', status: 'CLOSED' },
];

const refundLineRows = [
    { id: 1, lineId: 'BRL-2604-000101', breakdownRef: 'BD-2604-0001', ticketRef: 'TKT-556677', passenger: 'Nimal Perera', channel: 'CASH_ONBOARD', refundMode: 'CASH', amount: 'LKR 1,200.00', status: 'REFUNDED_BY_CONDUCTOR' },
    { id: 2, lineId: 'BRL-2604-000102', breakdownRef: 'BD-2604-0001', ticketRef: 'TKT-556678', passenger: 'Kamal Silva', channel: 'CASH_ONBOARD', refundMode: 'CASH', amount: 'LKR 1,200.00', status: 'REFUNDED_BY_CONDUCTOR' },
    { id: 3, lineId: 'BRL-2604-000103', breakdownRef: 'BD-2604-0001', ticketRef: 'ONB-778899', passenger: 'Shanika Dissanayake', channel: 'ONLINE_ONBOARD', refundMode: 'DIGITAL', amount: 'LKR 2,400.00', status: 'PENDING' },
    { id: 4, lineId: 'BRL-2604-000104', breakdownRef: 'BD-2604-0001', ticketRef: 'CARD-889900', passenger: 'Travel Card User', channel: 'TRAVEL_CARD', refundMode: 'DIGITAL', amount: 'LKR 1,850.00', status: 'PENDING' },
    { id: 5, lineId: 'BRL-2604-000105', breakdownRef: 'BD-2604-0002', ticketRef: 'TKT-990011', passenger: 'Mahesh Fernando', channel: 'COUNTER_BOOKING', refundMode: 'CASH', amount: 'LKR 1,500.00', status: 'PENDING' },
];

const actionLogRows = [
    { id: 1, actionType: 'REPORTED', actionBy: 'EMP1025\nSunil Perera', role: 'CONDUCTOR', actionTime: '20/04/2026 07:35', amount: '–', remarks: 'Breakdown reported from POS' },
    { id: 2, actionType: 'DEPOT_CONFIRMED', actionBy: 'DUSR001\nKasun Weerasekera', role: 'DEPOT_MANAGER', actionTime: '20/04/2026 07:55', amount: '–', remarks: 'Verified and confirmed' },
    { id: 3, actionType: 'CONDUCTOR_\nCASH_REFUND_CONFIRMED', actionBy: 'EMP1025\nSunil Perera', role: 'CONDUCTOR', actionTime: '20/04/2026 08:20', amount: 'LKR 65,800.00', remarks: 'Cash refunds completed' },
    { id: 4, actionType: 'DEPOT_DIGITAL_\nREFUND_CONFIRMED', actionBy: 'DUSR002\nNadeesha Perera', role: 'DEPOT_ACCOUNTS', actionTime: '20/04/2026 09:10', amount: 'LKR 128,400.00', remarks: 'Digital refund batch created' },
    { id: 5, actionType: 'HO_TRANSFER_\nAUTHORIZED', actionBy: 'HOUSR001\nSaman Wickrama', role: 'HO_ACCOUNTS', actionTime: '20/04/2026 11:05', amount: 'LKR 128,400.00', remarks: 'Authorized for bank transfer' },
    { id: 6, actionType: 'CLOSED', actionBy: 'DUSR001\nKasun Weerasekera', role: 'DEPOT_MANAGER', actionTime: '20/04/2026 11:20', amount: '–', remarks: 'Case closed' },
];

// ─── Status Chips ─────────────────────────────────────────────────────────────

const BreakdownStatusChip = ({ status }) => {
    const map = {
        DEPOT_CONFIRMED: '#2e7d32',
        CASH_REFUND_IN_PROGRESS: '#ed6c02',
        DEPOT_DIGITAL_PENDING: '#1565c0',
        HO_AUTH_PENDING: '#e65100',
        CLOSED: '#555',
    };
    return (
        <Chip
            label={status.replace(/_/g, '_')}
            size="small"
            sx={{
                backgroundColor: map[status] || '#999',
                color: '#fff',
                fontWeight: 600,
                fontSize: 10,
                height: 22,
                borderRadius: '4px',
                '& .MuiChip-label': { px: 1 },
                whiteSpace: 'normal',
                maxWidth: 160,
            }}
        />
    );
};

const RefundStatusChip = ({ status }) => {
    const map = {
        REFUNDED_BY_CONDUCTOR: '#2e7d32',
        PENDING: '#ed6c02',
        PROCESSING: '#1976d2',
        REJECTED: '#d32f2f',
    };
    return (
        <Chip
            label={status.replace(/_/g, '_')}
            size="small"
            sx={{
                backgroundColor: map[status] || '#999',
                color: '#fff',
                fontWeight: 600,
                fontSize: 10,
                height: 22,
                borderRadius: '4px',
                '& .MuiChip-label': { px: 1 },
                whiteSpace: 'normal',
                maxWidth: 160,
            }}
        />
    );
};

// ─── Pagination Hook ──────────────────────────────────────────────────────────

const usePagination = (defaultRows = 10) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(defaultRows);
    return {
        page, rowsPerPage,
        handleChangePage: (_, p) => setPage(p),
        handleChangeRowsPerPage: (e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); },
        startIndex: page * rowsPerPage,
    };
};

// ─── Component ────────────────────────────────────────────────────────────────

const BusBreakdownRefundPage = () => {

    // Filters
    const [dateFrom, setDateFrom] = useState('20/04/2026');
    const [dateTo, setDateTo] = useState('20/04/2026');
    const [status, setStatus] = useState('');
    const [depot, setDepot] = useState('');
    const [channel, setChannel] = useState('');
    const [route, setRoute] = useState('');
    const [busNo, setBusNo] = useState('');

    // Paginations
    const breakdownPag = usePagination();
    const refundLinePag = usePagination();
    const actionLogPag = usePagination();

    const thSx = { py: 1, fontWeight: 600, fontSize: 13 };
    const tdSx = { py: 0.5, fontSize: 13 };

    return (
        <Container component="main" maxWidth="full" sx={{ py: 0 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>

                {/* ── Page Title ── */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 3, flexWrap: 'wrap', gap: 2 }}>
                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                        Bus Breakdown Refund Management
                    </Typography>
                    <IconButton size="small"><MoreHorizIcon /></IconButton>
                </Box>

                {/* ── Summary Cards ── */}
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                        gap: 2,
                        width: '100%',
                        mb: 3,
                    }}
                >
                    {summaryCards.map((card) => (
                        <Paper
                            key={card.label}
                            variant="outlined"
                            sx={{ p: 2, borderRadius: 2, display: 'flex', alignItems: 'center', gap: 2 }}
                        >
                            <Box
                                sx={{
                                    backgroundColor: card.bg,
                                    borderRadius: 2,
                                    p: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {card.icon}
                            </Box>
                            <Box>
                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: 11 }}>
                                    {card.label}
                                </Typography>
                                <Typography
                                    variant="h5"
                                    sx={{ fontWeight: 700, color: card.color, lineHeight: 1.2, fontSize: 18, mt: 0.5, mb: card.sub ? 0.5 : 0 }}
                                >
                                    {card.value}
                                </Typography>
                                {card.sub && (
                                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: 11 }}>
                                        {card.sub}
                                    </Typography>

                                )}
                            </Box>
                        </Paper>
                    ))}
                </Box>

                {/* ── Filter Bar ── */}
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                        gap: 1.5,
                        width: '100%',
                        mb: 1,
                        alignItems: 'center',
                    }}
                >
                    <TextField
                        fullWidth size="small" label="Date From"
                        value={dateFrom} onChange={e => setDateFrom(e.target.value)}
                    />
                    <TextField
                        fullWidth size="small" label="Date To"
                        value={dateTo} onChange={e => setDateTo(e.target.value)}
                    />
                    <FormControl size="small" fullWidth>
                        <InputLabel>Status</InputLabel>
                        <Select value={status} onChange={e => setStatus(e.target.value)} label="Status">
                            <MenuItem value="">All Status</MenuItem>
                            <MenuItem value="DEPOT_CONFIRMED">Depot Confirmed</MenuItem>
                            <MenuItem value="CASH_REFUND_IN_PROGRESS">Cash Refund In Progress</MenuItem>
                            <MenuItem value="DEPOT_DIGITAL_PENDING">Depot Digital Pending</MenuItem>
                            <MenuItem value="HO_AUTH_PENDING">HO Auth Pending</MenuItem>
                            <MenuItem value="CLOSED">Closed</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl size="small" fullWidth>
                        <InputLabel>Depot</InputLabel>
                        <Select value={depot} onChange={e => setDepot(e.target.value)} label="Depot">
                            <MenuItem value="">All Depots</MenuItem>
                            <MenuItem value="GAL">Galle (GAL)</MenuItem>
                            <MenuItem value="KND">Kandy (KND)</MenuItem>
                            <MenuItem value="MRT">Maradana (MRT)</MenuItem>
                            <MenuItem value="NWP">Nawinna (NWP)</MenuItem>
                            <MenuItem value="KUR">Kallyapitiya (KUR)</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl size="small" fullWidth>
                        <InputLabel>Route</InputLabel>
                        <Select value={route} onChange={e => setRoute(e.target.value)} label="Route">
                            <MenuItem value="">All Routes</MenuItem>
                            <MenuItem value="001">001 Colombo - Kandy</MenuItem>
                            <MenuItem value="017">017 Kandy - Kurunegala</MenuItem>
                            <MenuItem value="025">025 Kurunegala - Puttalam</MenuItem>
                            <MenuItem value="027">027 Puttalam - Chilaw</MenuItem>
                            <MenuItem value="003">003 Kandy - Matale</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                        fullWidth size="small" label="Bus No."
                        value={busNo} onChange={e => setBusNo(e.target.value)}
                        placeholder="Select Bus"
                    />
                </Box>

                {/* ── Action Buttons ── */}
                <Box sx={{ display: 'flex', gap: 1.5, mb: 3, alignItems: 'center', width: '100%', justifyContent: 'flex-end' }}>
                    <Button
                        variant="contained"
                        startIcon={<SearchIcon />}
                        sx={{ padding: '6px 24px', fontWeight: 'bold', borderRadius: '4px', height: '40px', backgroundColor: '#3f51b5', color: '#fff', '&:hover': { backgroundColor: '#303f9f' } }}
                    >
                        Search
                    </Button>
                    <Button
                        variant="outlined"
                        startIcon={<RefreshIcon />}
                        sx={{ fontWeight: 'bold', borderRadius: '4px', height: '40px', textTransform: 'none' }}
                    >
                        Reset
                    </Button>
                    <Button
                        variant="outlined"
                        startIcon={<DownloadIcon />}
                        endIcon={<KeyboardArrowDownIcon />}
                        sx={{ fontWeight: 'bold', borderRadius: '4px', height: '40px', textTransform: 'none' }}
                    >
                        Export
                    </Button>
                </Box>

                {/* ══════════════════════════════════════════
                    TABLE 1 — Breakdown Events
                ══════════════════════════════════════════ */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>1. Breakdown Events</Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <IconButton size="small"><DownloadIcon /></IconButton>
                        <IconButton size="small"><MoreHorizIcon /></IconButton>
                    </Box>
                </Box>

                <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                <TableCell sx={thSx}></TableCell>
                                <TableCell sx={thSx}>Breakdown Ref No.</TableCell>
                                <TableCell sx={thSx}>Date &amp; Time</TableCell>
                                <TableCell sx={thSx}>Bus No.</TableCell>
                                <TableCell sx={thSx}>Route</TableCell>
                                <TableCell sx={thSx}>Stage / Location</TableCell>
                                <TableCell sx={thSx}>Conductor</TableCell>
                                <TableCell sx={thSx}>Pax (Est.)</TableCell>
                                <TableCell sx={thSx}>Cash Refund</TableCell>
                                <TableCell sx={thSx}>Digital Refund Due</TableCell>
                                <TableCell sx={thSx}>Net Cash Due to Depot</TableCell>
                                <TableCell sx={thSx}>Status</TableCell>
                                <TableCell sx={thSx}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {breakdownEventRows
                                .slice(breakdownPag.startIndex, breakdownPag.startIndex + breakdownPag.rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell sx={tdSx}>
                                            <AddIcon sx={{ fontSize: 16, color: '#888', cursor: 'pointer' }} />
                                        </TableCell>
                                        <TableCell sx={tdSx}>
                                            <Typography variant="body2" sx={{ color: '#1976d2', cursor: 'pointer', fontWeight: 600, '&:hover': { textDecoration: 'underline' }, fontSize: 13 }}>
                                                {row.refNo}
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={tdSx}>{row.dateTime}</TableCell>
                                        <TableCell sx={tdSx}>{row.busNo}</TableCell>
                                        <TableCell sx={tdSx}>{row.route}</TableCell>
                                        <TableCell sx={tdSx}>{row.stage}</TableCell>
                                        <TableCell sx={tdSx}>
                                            <Typography variant="body2" sx={{ fontSize: 12, whiteSpace: 'pre-line' }}>
                                                {row.conductor}
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={tdSx}>{row.pax}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 600 }}>{row.cashRefund}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 600 }}>{row.digitalRefund}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 700 }}>{row.netCash}</TableCell>
                                        <TableCell sx={tdSx}><BreakdownStatusChip status={row.status} /></TableCell>
                                        <TableCell sx={tdSx}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <Button
                                                    size="small"
                                                    startIcon={<VisibilityIcon sx={{ fontSize: 14 }} />}
                                                    sx={{ minWidth: 0, p: '2px 8px', borderRadius: '4px', border: '1px solid #ccc', color: '#555', textTransform: 'none', fontSize: 12 }}
                                                >
                                                    View
                                                </Button>
                                                <IconButton size="small" sx={{ p: 0.5 }}>
                                                    <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />
                                                </IconButton>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        showFirstButton showLastButton
                        component="div"
                        count={breakdownEventRows.length}
                        page={breakdownPag.page}
                        onPageChange={breakdownPag.handleChangePage}
                        rowsPerPage={breakdownPag.rowsPerPage}
                        onRowsPerPageChange={breakdownPag.handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </TableContainer>

                {/* ══════════════════════════════════════════
                    TABLE 2 — Breakdown Refund Lines
                ══════════════════════════════════════════ */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 4, flexWrap: 'wrap', gap: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>2. Breakdown Refund Lines (Ticket / Passenger)</Typography>
                    <IconButton size="small"><MoreHorizIcon /></IconButton>
                </Box>

 <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                        gap: 1.5,
                        width: '100%',
                        mb: 2,
                        alignItems: 'center',
                    }}
                >
                
                    <FormControl size="small" fullWidth>
                        <InputLabel>Depot</InputLabel>
                        <Select value={depot} onChange={e => setDepot(e.target.value)} label="Depot">
                            <MenuItem value="">All Depots</MenuItem>
                            <MenuItem value="GAL">Galle (GAL)</MenuItem>
                            <MenuItem value="KND">Kandy (KND)</MenuItem>
                            <MenuItem value="MRT">Maradana (MRT)</MenuItem>
                            <MenuItem value="NWP">Nawinna (NWP)</MenuItem>
                            <MenuItem value="KUR">Kallyapitiya (KUR)</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl size="small" fullWidth>
                        <InputLabel>Channel</InputLabel>
                        <Select value={channel} onChange={e => setChannel(e.target.value)} label="Channel">
                            <MenuItem value="">All Channel</MenuItem>
                            <MenuItem value="CASH_ONBOARD">CASH_ONBOARD</MenuItem>
                            <MenuItem value="ONLINE_ONBOARD">ONLINE_ONBOARD</MenuItem>
                            <MenuItem value="TRAVEL_CARD">TRAVEL_CARD</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                        fullWidth size="small" label="Bus No."
                        value={busNo} onChange={e => setBusNo(e.target.value)}
                        placeholder="Select Bus"
                    />
                </Box>

                <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                <TableCell sx={thSx}>Refund Line ID</TableCell>
                                <TableCell sx={thSx}>Breakdown Ref No.</TableCell>
                                <TableCell sx={thSx}>Ticket Ref No.</TableCell>
                                <TableCell sx={thSx}>Passenger</TableCell>
                                <TableCell sx={thSx}>Channel</TableCell>
                                <TableCell sx={thSx}>Refund Mode</TableCell>
                                <TableCell sx={thSx}>Refundable Amount</TableCell>
                                <TableCell sx={thSx}>Refund Status</TableCell>
                                <TableCell sx={thSx}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {refundLineRows
                                .slice(refundLinePag.startIndex, refundLinePag.startIndex + refundLinePag.rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell sx={tdSx}>{row.lineId}</TableCell>
                                        <TableCell sx={{ ...tdSx, color: '#1976d2', fontWeight: 600 }}>{row.breakdownRef}</TableCell>
                                        <TableCell sx={tdSx}>{row.ticketRef}</TableCell>
                                        <TableCell sx={tdSx}>{row.passenger}</TableCell>
                                        <TableCell sx={tdSx}>{row.channel}</TableCell>
                                        <TableCell sx={tdSx}>{row.refundMode}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 600 }}>{row.amount}</TableCell>
                                        <TableCell sx={tdSx}><RefundStatusChip status={row.status} /></TableCell>
                                        <TableCell sx={tdSx}>
                                            <Button
                                                size="small"
                                                sx={{ minWidth: 0, p: '2px 14px', borderRadius: '4px', border: '1px solid #ccc', color: '#555', textTransform: 'none', fontSize: 12 }}
                                            >
                                                View
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 1 }}>
                        <Typography variant="body2" color="text.secondary">
                            Showing 1 to 5 of 24 entries
                        </Typography>
                        <Button
                            variant="outlined"
                            size="small"
                            sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '4px' }}
                        >
                            View All Lines
                        </Button>
                    </Box> */}
                    <TablePagination
                        showFirstButton showLastButton
                        component="div"
                        count={refundLineRows.length}
                        page={refundLinePag.page}
                        onPageChange={refundLinePag.handleChangePage}
                        rowsPerPage={refundLinePag.rowsPerPage}
                        onRowsPerPageChange={refundLinePag.handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </TableContainer>

                {/* ══════════════════════════════════════════
                    TABLE 3 — Approval / Action Log
                ══════════════════════════════════════════ */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 4, flexWrap: 'wrap', gap: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>3. Approval / Action Log</Typography>
                    {/* <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                            variant="outlined"
                            size="small"
                            sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '4px' }}
                        >
                            View Full Log
                        </Button>
                        <IconButton size="small"><MoreHorizIcon /></IconButton>
                    </Box> */}
                </Box>

                <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                <TableCell sx={{ ...thSx, width: 24 }}></TableCell>
                                <TableCell sx={thSx}>Action Type</TableCell>
                                <TableCell sx={thSx}>Action By</TableCell>
                                <TableCell sx={thSx}>Role</TableCell>
                                <TableCell sx={thSx}>Action Time</TableCell>
                                <TableCell sx={thSx}>Amount (LKR)</TableCell>
                                <TableCell sx={thSx}>Remarks</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {actionLogRows
                                .slice(actionLogPag.startIndex, actionLogPag.startIndex + actionLogPag.rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell sx={{ ...tdSx, py: 1 }}>
                                            <CircleIcon sx={{ fontSize: 10, color: '#1976d2' }} />
                                        </TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 600, whiteSpace: 'pre-line', fontSize: 12 }}>
                                            {row.actionType}
                                        </TableCell>
                                        <TableCell sx={{ ...tdSx, whiteSpace: 'pre-line', fontSize: 12 }}>
                                            {row.actionBy}
                                        </TableCell>
                                        <TableCell sx={tdSx}>{row.role}</TableCell>
                                        <TableCell sx={tdSx}>{row.actionTime}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 600 }}>{row.amount}</TableCell>
                                        <TableCell sx={tdSx}>{row.remarks}</TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        showFirstButton showLastButton
                        component="div"
                        count={actionLogRows.length}
                        page={actionLogPag.page}
                        onPageChange={actionLogPag.handleChangePage}
                        rowsPerPage={actionLogPag.rowsPerPage}
                        onRowsPerPageChange={actionLogPag.handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </TableContainer>

            </Box>
        </Container>
    );
};

export default BusBreakdownRefundPage;